import(/* webpackMode: "eager", webpackExports: ["BuyerGuidesPage"] */ "/app/src/app/(browse)/buyer-guides/BuyerGuidesPage.tsx");
